// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto } from './IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto';
import {
    IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto';
import type { ICipStatusMultiEmployersSummaryRecordDto } from './ICipStatusMultiEmployersSummaryRecordDto';
import {
    ICipStatusMultiEmployersSummaryRecordDtoFromJSON,
    ICipStatusMultiEmployersSummaryRecordDtoFromJSONTyped,
    ICipStatusMultiEmployersSummaryRecordDtoToJSON,
    ICipStatusMultiEmployersSummaryRecordDtoToJSONTyped,
} from './ICipStatusMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDto
 */
export interface IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<ICipStatusMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDto
     */
    employer_records?: Array<ICipStatusMultiEmployersSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoCipStatusMultiEmployersSummaryRecordDto(value: object): value is IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDto {
    return IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(ICipStatusMultiEmployersSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDtoToJSON(json: any): IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDto {
    return IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoCipStatusMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(ICipStatusMultiEmployersSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDtoToJSON)),
    };
}

